import { render, staticRenderFns } from "./FCCMigex.vue?vue&type=template&id=0b77666b&scoped=true"
import script from "./FCCMigex.vue?vue&type=script&lang=js"
export * from "./FCCMigex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77666b",
  null
  
)

export default component.exports